import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Usuario} from '../../model/usuario';
import {GlobalService} from '../global.service';
import {UtilApi} from './util.api';
import {TipoDeEvento} from '../../model/catalogo';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class AutenticacaoApiService {

    constructor(private http: HttpClient, private globalService: GlobalService) {
    }

    loginUsuario(chave: string, senha: string, escopo: string, certificado: boolean, ambiente: string): Observable<Usuario> {

        let dados = new HttpParams();
        chave = chave.toLowerCase();
        let url: string;


        if (certificado == true) {
            dados = dados.append('grant_type', 'password');
            dados = dados.append('scope', escopo);
            dados = dados.append('username', chave.toLowerCase());
            dados = dados.append('password', senha);
            url = this.globalService.getConfiguracao().api_autorizador_certificado + '/autoriza';
        } else {
            dados = dados.append('grant_type', 'password');
            dados = dados.append('scope', escopo);
            dados = dados.append('username', chave.toLowerCase());
            dados = dados.append('password', senha);

            if (ambiente != '') {
                switch (ambiente) {
                    case 'DES':
                        url = environment.configDesenv.api_autorizador + '/autoriza';
                        break;
                    case 'HMG':
                        url = environment.configHm.api_autorizador + '/autoriza';
                        break;
                    case 'PRD':
                        url = environment.configProd.api_autorizador + '/autoriza';
                        break;
                }
            } else {
                url = this.globalService.getConfiguracao().api_autorizador + '/autoriza';
            }


        }

        return this.http.post<Usuario>(url, dados, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}});
    }
}



// WEBPACK FOOTER //
// ./src/service/api/autenticacao.api.ts